import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  BootstrapTable,
  TableHeaderColumn
} from 'react-bootstrap-table'
import { Button } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import CompanyNavigation from './companynavigation'
import Collapsible from '../collapsible'
import PaymentDetails from '../invoices/paymentdetailsmodal'
import CreatePackingSlip from '../invoices/createpackingslipmodal'

@observer(['companies', 'orders', 'quotes'])
export default class Orders extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openPaymentDetailModal: false,
      openCreatePackingSlipModal: false,
      quoteId: 0,
      activeRow: {}
    }

    this.props.companies.loadCompanyDetails({id: this.props.params.companyId, hash: localStorage.getItem('userHash')})
    this.props.companies.loadCompanyOrders(this.props.params.companyId)
  }

  priceFormatter(cell, row) {
    return '$' + cell.toFixed(2)
  }

  onPaymentDetailButtonClick(row) {
    this.setState({
      openPaymentDetailModal: true,
      activeRow: row
    }, () => {
      console.log('ActiveRow: ', this.state.activeRow)
    })
  }

  closePaymentDetailModal() {
    this.setState({
      openPaymentDetailModal: false,
      activeRow: {}
    })
  }

  deleteOrder(id) {
    if(confirm('Are you sure you want to delete this order?  This action cannot be undone!')) {
      this.props.orders.deleteOrder(id, () => { this.props.companies.loadCompanyOrders(this.props.params.companyId) })
    }
  }

  openCreatePackingSlipForm(row) {
    this.setState({
      openCreatePackingSlipModal: true,
      quoteId: row.quoteId
    })
  }

  closeCreatePackingSlipModal() {
    this.setState({
      openCreatePackingSlipModal: false,
      quoteId: 0
    })
  }

  formatActions(cell, row) {
    let paymentDetailsButton = (<Button bsSize="small" bsStyle="warning" disabled={true} id={ row.paymentId } ><i className="fa fa-credit-card" aria-hidden="true"></i></Button>)
    
    if (row.paymentId) {
      paymentDetailsButton = (<Button bsSize="small" bsStyle="warning" id={ row.paymentId } onClick={ () => { this.onPaymentDetailButtonClick(row) } }><i className="fa fa-credit-card" aria-hidden="true"></i></Button>)
    }

    return (
      <div>
        <Button bsSize="small" bsStyle="info" id={ row.id } onClick={ () => { browserHistory.push('/order/' + row.id) } }><i className="fa fa-file-pdf-o" aria-hidden="true"></i></Button>
        { paymentDetailsButton }
        <Button bsSize="small" bsStyle="success" id={ row.id } onClick={ () => { this.openCreatePackingSlipForm(row) } }><i className="fa fa-newspaper-o" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={ row.id } onClick={ () => { this.deleteOrder(row.id) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
    )
  }

  render() {
    const options = {
      defaultSortName: 'id',
      defaultSortOrder: 'desc'
    }

    const ordersTable = (
      <div>
        <BootstrapTable
            data={ this.props.companies.orders }
            striped={ true }
            hover={ true }
            pagination={ true }
            search={ true }
            options={ options }
          >
          <TableHeaderColumn width="100" dataField="id" isKey={ true } dataSort={ true } dataAlign="center">CRM Order #</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="formattedOrderDate" dataSort={ true }>Order Date</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="quoteType" dataSort={ true }>Type</TableHeaderColumn>
          { /* <TableHeaderColumn width="100" dataField="orderStatus" dataSort={ true }>Status</TableHeaderColumn> */ }
          <TableHeaderColumn width="100" dataField="oneTimeTotal" dataFormat={ this.priceFormatter.bind(this) } dataSort={ true }>Total</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="paymentAmount" dataFormat={ this.priceFormatter.bind(this) } dataSort={ true }>Payment</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="balance" dataFormat={ this.priceFormatter.bind(this) } dataSort={ true }>Balance</TableHeaderColumn>
          <TableHeaderColumn width="150" datafield="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <CompanyNavigation activeKey="3" companyId={ this.props.params.companyId } companyStateId={ this.props.companies.details.companyStateId } companyName={ this.props.companies.details.name } />
        <div>
          <div className="clearfix"></div>
          <Collapsible title="Orders" content={ ordersTable } />
        </div>
        <PaymentDetails open={this.state.openPaymentDetailModal} activeRow={this.state.activeRow} onClose={this.closePaymentDetailModal.bind(this)} />
        <CreatePackingSlip open={this.state.openCreatePackingSlipModal} quoteId={this.state.quoteId} onClose={this.closeCreatePackingSlipModal.bind(this)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/orders.js